"use strict";
var SoaCollection = require('bunsen/collections/SoaCollection');
var Seller = require('bunsen/models/Seller');
var fetchDiscrete = require('bunsen/helpers/fetchDiscrete');
var Sellers = module.exports = SoaCollection.extend({}, fetchDiscrete);
var endpoints = require('dibs-endpoints');
var _ = require('underscore');
var $ = require('dibs-jquery-shim');

_.extend(Sellers.prototype, {
    model: Seller,
    url: function () {
        var ret = _.result(endpoints, 'sellers');
        if (this._discreteIds) {
            ret += "?" + $.param(_.extend({sellerId: this._discreteIds.join(',')}));
        }
        return ret;
    },
    parseQuery: function (query) {
        var matches = "string" === typeof query ? query.match(/^(([a-z]_[0-9]+(\s*,\s*[a-z]_[0-9]+)*)|(.+@.+)|(.*))$/i) : [];
        return {
            sellerId: matches[2] && (matches[2].toLowerCase()).split(/\s*,\s*/).join(","),
            email: matches[4],
            company: matches[5]
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/collections/identity/Sellers.js
// module id = 2611
// module chunks = 62